// @ts-nocheck
import React, { FC } from 'react';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import useMediaQuery from 'Shared/Hooks/useMediaQuery';
import Price from 'crehana-ui/Text/Price';
import { Product } from '../types';

interface BasicInfoProps {
  product: Product;
  canRenderBuyButton?: boolean;
  canShowPrice?: boolean;
}

const BasicInfo: FC<BasicInfoProps> = ({
  product: { name, discount, description, buttonLabel, url, prices },
  canRenderBuyButton = true,
  canShowPrice = true,
}) => {
  const { matches } = useMediaQuery('md');

  return (
    <>
      <div>
        <div className="mb-24">
          <p className="font-h3 text-white mb-8 sm:mb-4 lg:mb-8 ">{name}</p>
          {discount && (
            <p className="font-button text-yellow-main">{discount}</p>
          )}
        </div>
        <p className="font-body2 text-white">{description}</p>
      </div>
      {canShowPrice && prices && (
        <Price
          s
          className="mt-24 sm:mt-40"
          currency={prices.currency}
          price={prices.price}
          priceColor="white"
          realPriceColor="white"
          currencyColor="white"
          realPrice={prices.realPrice}
        />
      )}
      {canRenderBuyButton && (
        <PrimaryButton
          darkMode
          full={!matches}
          className="mt-24 lg:w-280"
          label={buttonLabel}
          size="l"
          onClick={() => {
            window.location.href = url;
          }}
        />
      )}
    </>
  );
};

export default BasicInfo;
